export enum Platform {
  WEBCHAT = "webchat",
}

export enum MsgType {
  TEXT = "text",
  PICTURE = "picture",
  VIDEO = "video",
  FILE = "file",
  AUDIO = "audio",
}

export enum FileType {
  MP3 = "mp3",
  WAV = "wav",
  DOC = "doc",
  DOCX = "docx",
  TXT = "txt",
  RTF = "rtf",
  PDF = "pdf",
  ZIP = "zip",
  RAR = "rar",
  SZIP = "7zip",
  XLSX = "xlsx",
  XLS = "xls",
  CSV = "csv",
  ODS = "ods",
  ODT = "odt",
}

export enum MsgActionType {
  LOG = "log", // user sends message to bot in bot conversation
  BOT_RESPONSE = "bot_response", // bot response to user in bot conversation
  RESPOND = "respond", // users sends message to agent
  AGENT_RESPONSE = "agent_response", // agent response to user
}

export enum Tokens {
  AUTH_TOKEN = "jwtAuthToken",
  GUEST_TOKEN = "jwtGuestToken",
}

export interface BotAppKeyboardButton {
  readonly Text: string;
  readonly ActionBody: string;
  readonly ActionType: string;
  readonly Columns: number;
  readonly Rows: number;
  readonly TextOpacity?: number;
  readonly TextHAlign?: "middle" | "left" | "right";
  readonly TextVAlign?: "middle" | "top" | "bottom";
  readonly TextSize?: "large" | "regular" | "small";
  readonly BgColor?: string;
  readonly Image?: string;
}

export interface keyboardObject {
  Type: string;
  Buttons: BotAppKeyboardButton[];
  InputFieldState?: "regular" | "minimized" | "hidden";
}

export interface IConversationMessage {
  _id: string;
  msg: {
    name: string;
    platform?: Platform;
    text?: string;
    message_token?: number;
    avatar?: string;
    media?: string;
    keyboard?: keyboardObject;
  };
  identity: string;
  conversation: string;
  type: MsgType;
  source: string;
  sentToRoom: string;
  sentToAgent: string | null;
  action: MsgActionType;
  createdAt: string;
  updatedAt: string;
  notDelivered?: boolean;
  sentMsg: boolean;
}

export interface ISentMessage {
  msg: {
    name: string;
    avatar?: string;
    text?: string;
  };
  type: MsgType;
  createdAt: string;
  action: MsgActionType;
  sentMsg: boolean;
}

export interface IFileAttachment {
  url: string;
  fileName: string;
  size: number;
  mimeType: string;
  thumbnail?: string;
}

export interface INewConversationMessage {
  msg: {
    text?: string;
    file?: IFileAttachment;
  };
  type: MsgType;
}

export interface IAttachment {
  filename: string;
  data: string;
  mimeType: string;
  size: number;
  attachmentId: string;
  thumbnail?: string;
}
